(function () {
  function parsePriceValue(value, fallback) {
    var normalized = String(value || '').trim().replace(/\s/g, '').replace(/[^\d.,-]/g, '');
    var lastComma = normalized.lastIndexOf(',');
    var lastDot = normalized.lastIndexOf('.');
    if (lastComma > -1 && lastDot > -1) {
      normalized = lastComma > lastDot
        ? normalized.replace(/\./g, '').replace(',', '.')
        : normalized.replace(/,/g, '');
    } else if (lastComma > -1) {
      var commaParts = normalized.split(',');
      normalized = commaParts.length > 2 || (commaParts[1] && commaParts[1].length === 3)
        ? commaParts.join('')
        : normalized.replace(',', '.');
    } else if (lastDot > -1) {
      var dotParts = normalized.split('.');
      if (dotParts.length > 2 || (dotParts[1] && dotParts[1].length === 3)) {
        normalized = dotParts.join('');
      }
    }
    normalized = normalized.replace(/(?!^)-/g, '');
    var parsed = parseFloat(normalized);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function formatPriceValue(value) {
    var rounded = Math.round(Number(value) * 100) / 100;
    if (!Number.isFinite(rounded)) return '';
    return Number.isInteger(rounded) ? String(rounded) : rounded.toFixed(2).replace(/0+$/, '').replace(/\.$/, '');
  }

  function buildGroupedFilterRemovalUrl(link) {
    var paramName = link && link.dataset.filterRemoveParam;
    var rawValues = link && link.dataset.filterRemoveValues || '';
    if (!paramName || !rawValues) return null;

    var removeValues = rawValues.split('|||').map(function (value) {
      return String(value || '').trim();
    }).filter(Boolean);
    if (!removeValues.length) return null;

    var url = new URL(window.location.href);
    var keepValues = url.searchParams.getAll(paramName).filter(function (value) {
      return removeValues.indexOf(String(value)) === -1;
    });

    url.searchParams.delete(paramName);
    keepValues.forEach(function (value) {
      url.searchParams.append(paramName, value);
    });

    return url;
  }

  function initFilterRenderer(options) {
    var config = options || {};
    var rootSelector = config.rootSelector;
    if (!rootSelector) return;

    var scope = config.scope && config.scope.querySelector ? config.scope : document;
    var root = scope.querySelector(rootSelector) || document.querySelector(rootSelector);
    if (!root || root.dataset.filterRendererInitialized === 'true') return;
    root.dataset.filterRendererInitialized = 'true';

    var filterSubmitTimer = null;
    var filterPreviewTimer = null;
    var activeFetchController = null;
    var activePreviewFetchController = null;
    var stickyFilterResizeObserver = null;
    var stickyFilterResizeHandler = null;

    function getSectionId() {
      return root.dataset.sectionId || '';
    }

    function getFilterDrawer() {
      var sectionId = getSectionId();
      return root.querySelector('#filterDrawer') ||
        document.querySelector('#filterDrawer[data-filter-drawer-owner="' + sectionId + '"]') ||
        document.getElementById('filterDrawer');
    }

    function getStickyFilterTrigger() {
      var sectionId = getSectionId();
      return root.querySelector('[data-sticky-filter-trigger]') ||
        document.querySelector('[data-sticky-filter-trigger][data-sticky-filter-trigger-owner="' + sectionId + '"]');
    }

    function getOpenFilterButtons() {
      var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-open-filter-drawer]'));
      var trigger = getStickyFilterTrigger();
      if (trigger) {
        trigger.querySelectorAll('[data-open-filter-drawer]').forEach(function (button) {
          if (buttons.indexOf(button) === -1) buttons.push(button);
        });
      }
      return buttons;
    }

    function setOpenFilterButtonsExpanded(isExpanded) {
      getOpenFilterButtons().forEach(function (button) {
        button.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
      });
    }

    function removePortaledFilterDrawer() {
      var sectionId = getSectionId();
      document.querySelectorAll('#filterDrawer[data-filter-drawer-portal="true"]').forEach(function (drawer) {
        if (!sectionId || drawer.dataset.filterDrawerOwner === sectionId) drawer.remove();
      });
    }

    function portalFilterDrawer() {
      var filterDrawer = root.querySelector('#filterDrawer');
      if (!filterDrawer || filterDrawer.dataset.filterDrawerPortal === 'true') return;
      removePortaledFilterDrawer();
      filterDrawer.dataset.filterDrawerPortal = 'true';
      filterDrawer.dataset.filterDrawerOwner = getSectionId();
      document.body.appendChild(filterDrawer);
    }

    function removePortaledStickyFilterTrigger() {
      var sectionId = getSectionId();
      document.querySelectorAll('[data-sticky-filter-trigger][data-sticky-filter-trigger-portal="true"]').forEach(function (trigger) {
        if (!sectionId || trigger.dataset.stickyFilterTriggerOwner === sectionId) trigger.remove();
      });
    }

    function portalStickyFilterTrigger() {
      var trigger = root.querySelector('[data-sticky-filter-trigger]');
      if (!trigger || trigger.dataset.stickyFilterTriggerPortal === 'true') return;
      removePortaledStickyFilterTrigger();
      trigger.dataset.stickyFilterTriggerPortal = 'true';
      trigger.dataset.stickyFilterTriggerOwner = getSectionId();
      document.body.appendChild(trigger);
    }

    function getMain() {
      return root.querySelector(config.mainSelector || '.collection-main');
    }

    function setScrollToTopOffset(offset) {
      document.documentElement.style.setProperty('--scroll-to-top-sticky-offset', Math.max(0, offset || 0) + 'px');
    }

    function updateScrollToTopOffset() {
      var trigger = getStickyFilterTrigger();
      if (!trigger) {
        setScrollToTopOffset(0);
        return;
      }
      var rect = trigger.getBoundingClientRect();
      setScrollToTopOffset(rect.height + 16);
    }

    function revealRenderedContent(sectionElement) {
      if (!sectionElement) return;
      if (window.Axiom && typeof window.Axiom.revealElements === 'function') {
        window.Axiom.revealElements(sectionElement, {
          trigger: 'manual',
          reset: true,
          stagger: 56
        });
      }
    }

    function setFilteringState(isFiltering) {
      var main = getMain();
      if (main) main.classList.toggle('is-filtering', Boolean(isFiltering));
      root.classList.toggle('is-filtering', Boolean(isFiltering));
    }

    function getFormControls(form) {
      if (!form) return [];
      var controls = Array.prototype.slice.call(form.elements || []);
      if (form.id && window.CSS && CSS.escape) {
        root.querySelectorAll('[form="' + CSS.escape(form.id) + '"]').forEach(function (input) {
          if (controls.indexOf(input) === -1) controls.push(input);
        });
      }
      return controls;
    }

    function syncFilterVisual(input) {
      var label = input.closest('.filter-check-item, .size-chip, .color-filter-item');
      if (!label) return;
      label.classList.toggle('checked', input.checked);
      label.classList.toggle('active', input.checked);
      var dot = label.querySelector('.color-dot');
      if (dot) dot.classList.toggle('selected', input.checked);
    }

    function captureFilterDropdownState(group) {
      return Array.prototype.slice.call(group.querySelectorAll('[data-native-filter-input]')).map(function (input) {
        return {
          checked: input.checked,
          value: input.value
        };
      });
    }

    function restoreFilterDropdownState(group) {
      var state = group && group._filterDropdownCommittedState;
      if (!state) return;
      var inputs = Array.prototype.slice.call(group.querySelectorAll('[data-native-filter-input]'));
      inputs.forEach(function (input, index) {
        if (!state[index]) return;
        input.checked = state[index].checked;
        input.value = state[index].value;
        syncFilterVisual(input);
      });
      inputs.filter(function (input) {
        return input.matches('[data-price-min-input], [data-price-max-input]');
      }).forEach(function (input) {
        input.dispatchEvent(new Event('input', { bubbles: true }));
      });
    }

    function filterDropdownHasChanges(group) {
      var state = group && group._filterDropdownCommittedState;
      if (!state) return false;
      var inputs = Array.prototype.slice.call(group.querySelectorAll('[data-native-filter-input]'));
      if (inputs.length !== state.length) return true;
      return inputs.some(function (input, index) {
        var snapshot = state[index];
        if (!snapshot) return true;
        return input.checked !== snapshot.checked || input.value !== snapshot.value;
      });
    }

    function updateFilterDropdownActions(group) {
      if (!group) return;
      var save = group.querySelector('[data-filter-dropdown-save]');
      if (save) save.disabled = !filterDropdownHasChanges(group);
    }

    function resetFilterDropdownReveal(group) {
      var panel = group && group.querySelector('.filter-group-body--dropdown');
      if (!panel) return;
      panel.removeAttribute('data-reveal-state');
      panel.querySelectorAll('[data-reveal-item]').forEach(function (item) {
        item.removeAttribute('data-reveal-ready');
        item.removeAttribute('data-reveal-state');
        item.style.removeProperty('--reveal-calculated-delay');
      });
    }

    function closeFilterDropdown(group, restoreDraft, returnFocus) {
      if (!group) return;
      var toggle = group.querySelector('[data-filter-dropdown-toggle]');
      var panel = group.querySelector('.filter-group-body--dropdown');
      if (restoreDraft) restoreFilterDropdownState(group);
      group.classList.remove('open', 'filter-group--dropdown-align-end');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      if (panel) panel.hidden = true;
      resetFilterDropdownReveal(group);
      if (window.AxiomOpenFilterDropdown && window.AxiomOpenFilterDropdown.group === group) {
        window.AxiomOpenFilterDropdown = null;
      }
      if (returnFocus && toggle) toggle.focus({ preventScroll: true });
    }

    function openFilterDropdown(group) {
      if (!group) return;
      var toggle = group.querySelector('[data-filter-dropdown-toggle]');
      var panel = group.querySelector('.filter-group-body--dropdown');
      if (!toggle || !panel) return;

      var current = window.AxiomOpenFilterDropdown;
      if (current && current.group !== group && typeof current.close === 'function') {
        current.close(false);
      }

      group._filterDropdownCommittedState = captureFilterDropdownState(group);
      group.classList.add('open');
      toggle.setAttribute('aria-expanded', 'true');
      panel.hidden = false;
      updateFilterDropdownActions(group);
      if (window.Axiom && typeof window.Axiom.revealElements === 'function') {
        window.Axiom.revealElements(panel, {
          trigger: 'open',
          selector: '[data-reveal-item]',
          reset: true,
          stagger: 45
        });
      }
      group.classList.remove('filter-group--dropdown-align-end');
      var panelRect = panel.getBoundingClientRect();
      if (panelRect.right > window.innerWidth - 16) {
        group.classList.add('filter-group--dropdown-align-end');
      }

      window.AxiomOpenFilterDropdown = {
        group: group,
        root: root,
        close: function (returnFocus) {
          closeFilterDropdown(group, true, returnFocus);
        }
      };
    }

    function resetFilterDropdown(group) {
      if (!group) return;
      var inputs = Array.prototype.slice.call(group.querySelectorAll('[data-native-filter-input]'));
      inputs.forEach(function (input) {
        if (input.type === 'checkbox' || input.type === 'radio') {
          input.checked = false;
        } else if (input.matches('[data-price-min-input], [data-price-max-input]')) {
          input.value = input.dataset.priceDefault || '';
        }
        syncFilterVisual(input);
      });
      inputs.filter(function (input) {
        return input.matches('[data-price-min-input], [data-price-max-input]');
      }).forEach(function (input) {
        input.dispatchEvent(new Event('input', { bubbles: true }));
      });
      updateFilterDropdownActions(group);
    }

    function bindFilterDropdowns() {
      root.querySelectorAll('[data-filter-dropdown]').forEach(function (group) {
        if (group.dataset.filterDropdownBound === 'true') return;
        group.dataset.filterDropdownBound = 'true';
        var toggle = group.querySelector('[data-filter-dropdown-toggle]');
        var reset = group.querySelector('[data-filter-dropdown-reset]');
        var save = group.querySelector('[data-filter-dropdown-save]');

        if (toggle) {
          toggle.addEventListener('click', function () {
            if (group.classList.contains('open')) {
              closeFilterDropdown(group, true, false);
              return;
            }
            openFilterDropdown(group);
          });
        }
        if (reset) {
          reset.addEventListener('click', function () {
            resetFilterDropdown(group);
            var form = root.querySelector(config.desktopFormSelector || '#collection-filters-form');
            submitFilterPreview(form, 0);
          });
        }
        if (save) {
          save.addEventListener('click', function () {
            var form = root.querySelector(config.desktopFormSelector || '#collection-filters-form');
            closeFilterDropdown(group, false, false);
            submitFilterForm(form, 0);
          });
        }
        group.addEventListener('input', function () {
          updateFilterDropdownActions(group);
        });
        group.addEventListener('change', function () {
          updateFilterDropdownActions(group);
        });
        updateFilterDropdownActions(group);
      });

      if (window.AxiomFilterDropdownGlobalBound) return;
      window.AxiomFilterDropdownGlobalBound = true;
      document.addEventListener('pointerdown', function (event) {
        var current = window.AxiomOpenFilterDropdown;
        if (!current) return;
        if (!current.root || !current.root.isConnected || !current.group || !current.group.isConnected) {
          window.AxiomOpenFilterDropdown = null;
          return;
        }
        if (!current.group.contains(event.target) && typeof current.close === 'function') {
          current.close(false);
        }
      });
      document.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') return;
        var current = window.AxiomOpenFilterDropdown;
        if (!current || typeof current.close !== 'function') return;
        event.preventDefault();
        current.close(true);
      });
    }

    function getSerializedFilterUrl(form) {
      var url = new URL((form && form.action) || window.location.href, window.location.origin);
      url.search = '';

      getFormControls(form).forEach(function (input) {
        if (!input.name || input.disabled) return;
        if ((input.type === 'checkbox' || input.type === 'radio') && !input.checked) return;
        if (input.type === 'submit' || input.type === 'button') return;
        if (input.value === '' || input.value === null || input.value === undefined) return;
        if (input.matches && input.matches('[data-price-min-input], [data-price-max-input]')) {
          var currentPrice = parsePriceValue(input.value, null);
          var defaultPrice = parsePriceValue(input.dataset.priceDefault, null);
          if (currentPrice === null) return;
          if (currentPrice !== null && defaultPrice !== null && currentPrice === defaultPrice) return;
          url.searchParams.append(input.name, formatPriceValue(currentPrice));
          return;
        }
        url.searchParams.append(input.name, input.value);
      });

      return url;
    }

    function getFilterInputKey(input) {
      if (!input || !input.name) return '';
      return input.name + '\u0000' + input.value;
    }

    function updateFilterOptionState(input, nextInput) {
      if (!input || input.matches('[data-price-min-input], [data-price-max-input]')) return;

      input.disabled = nextInput ? nextInput.disabled : !input.checked;

      var label = input.closest('.filter-check-item, .size-chip, .color-filter-item');
      var nextLabel = nextInput
        ? nextInput.closest('.filter-check-item, .size-chip, .color-filter-item')
        : null;
      if (!label) return;

      var currentCount = label.querySelector('.filter-check-count');
      var nextCount = nextLabel ? nextLabel.querySelector('.filter-check-count') : null;
      if (currentCount && nextCount) currentCount.textContent = nextCount.textContent;

      var labelInputs = Array.prototype.slice.call(label.querySelectorAll('[data-native-filter-input]'));
      var unavailable = labelInputs.length > 0 && labelInputs.every(function (labelInput) {
        return labelInput.disabled && !labelInput.checked;
      });

      if (label.classList.contains('size-chip')) {
        label.classList.toggle('unavailable', unavailable);
      } else {
        label.classList.toggle('is-disabled', unavailable);
      }
    }

    function updateFilterGroupAvailableCount(group, nextGroup) {
      if (!group || !nextGroup) return;
      var count = group.querySelector('[data-filter-group-available-count]');
      var nextCount = nextGroup.querySelector('[data-filter-group-available-count]');
      if (!count || !nextCount) return;

      count.textContent = nextCount.textContent;
      count.hidden = nextCount.hidden;
    }

    function renderFilterPreview(nextDocument, form) {
      if (!nextDocument || !form || !form.isConnected) return;
      var formSelector = form.id ? '#' + form.id : (config.mobileFormSelector || '#mobile-collection-filters-form');
      var nextForm = nextDocument.querySelector(formSelector);
      if (!nextForm) return;

      var nextInputsByKey = Object.create(null);
      nextForm.querySelectorAll('[data-native-filter-input]').forEach(function (input) {
        var key = getFilterInputKey(input);
        if (key) nextInputsByKey[key] = input;
      });

      form.querySelectorAll('[data-native-filter-input]').forEach(function (input) {
        updateFilterOptionState(input, nextInputsByKey[getFilterInputKey(input)] || null);
      });

      var nextGroupsByParam = Object.create(null);
      nextForm.querySelectorAll('[data-native-filter-group]').forEach(function (group) {
        nextGroupsByParam[group.dataset.nativeFilterGroup || ''] = group;
      });
      form.querySelectorAll('[data-native-filter-group]').forEach(function (group) {
        updateFilterGroupAvailableCount(group, nextGroupsByParam[group.dataset.nativeFilterGroup || '']);
      });
    }

    function cancelFilterPreview() {
      clearTimeout(filterPreviewTimer);
      filterPreviewTimer = null;
      if (activePreviewFetchController) {
        activePreviewFetchController.abort();
        activePreviewFetchController = null;
      }
    }

    function fetchFilterPreview(form) {
      var sectionId = getSectionId();
      if (!sectionId || !form || !form.isConnected) return;

      if (activePreviewFetchController) activePreviewFetchController.abort();
      var previewController = new AbortController();
      activePreviewFetchController = previewController;

      var previewUrl = getSerializedFilterUrl(form);
      previewUrl.searchParams.set('section_id', sectionId);

      fetch(previewUrl.toString(), {
        headers: { 'Accept': 'text/html' },
        signal: previewController.signal
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Filter preview request failed');
          return response.text();
        })
        .then(function (html) {
          if (activePreviewFetchController !== previewController) return;
          var parser = new DOMParser();
          renderFilterPreview(parser.parseFromString(html, 'text/html'), form);
        })
        .catch(function (error) {
          if (error && error.name === 'AbortError') return;
          console.error(error);
        })
        .finally(function () {
          if (activePreviewFetchController === previewController) {
            activePreviewFetchController = null;
          }
        });
    }

    function submitFilterPreview(form, delay) {
      if (!form) return;
      clearTimeout(filterPreviewTimer);
      filterPreviewTimer = setTimeout(function () {
        filterPreviewTimer = null;
        fetchFilterPreview(form);
      }, delay || 0);
    }

    function closeFilterDrawer() {
      var filterDrawer = getFilterDrawer();
      if (!filterDrawer) return;
      filterDrawer.classList.remove('is-open');
      filterDrawer.setAttribute('aria-hidden', 'true');
      if (!filterDrawer.classList.contains('filter-drawer--panel')) {
        document.body.style.overflow = '';
      }
      setOpenFilterButtonsExpanded(false);
    }

    function openFilterDrawer() {
      var filterDrawer = getFilterDrawer();
      if (!filterDrawer) return;
      filterDrawer.classList.add('is-open');
      filterDrawer.setAttribute('aria-hidden', 'false');
      if (!filterDrawer.classList.contains('filter-drawer--panel')) {
        document.body.style.overflow = 'hidden';
      }
      setOpenFilterButtonsExpanded(true);
      filterDrawer.focus();
    }

    function replaceRenderedSection(nextDocument, url, requestOptions) {
      var sectionId = getSectionId();
      var currentSection = sectionId ? document.getElementById('shopify-section-' + sectionId) : null;
      var nextSection = sectionId ? nextDocument.getElementById('shopify-section-' + sectionId) : null;
      var nextRoot = nextDocument.querySelector(rootSelector);

      removePortaledFilterDrawer();
      removePortaledStickyFilterTrigger();

      if (currentSection && nextSection) {
        currentSection.replaceWith(nextSection);
        revealRenderedContent(nextSection);
      } else if (nextRoot && root.parentNode) {
        root.replaceWith(nextRoot);
        revealRenderedContent(nextRoot);
      } else {
        throw new Error('Rendered filter payload missing root');
      }

      if (!requestOptions || requestOptions.updateHistory !== false) {
        window.history.pushState({}, '', url.toString());
      }

      document.body.style.overflow = '';
      if (typeof config.afterRender === 'function') {
        config.afterRender(document);
      } else {
        initFilterRenderer(config);
      }

      document.dispatchEvent(new CustomEvent('axiom:section-rendered', {
        detail: {
          sectionId: sectionId,
          source: 'filter-renderer'
        }
      }));
    }

    function dispatchStandardUpdate(url, promise) {
      if (!window.AxiomStandardStorefront) return;
      if (root.matches('[data-search-page]') && typeof window.AxiomStandardStorefront.dispatchSearchUpdate === 'function') {
        window.AxiomStandardStorefront.dispatchSearchUpdate(root, promise, url);
        return;
      }
      if (root.matches('[data-collection-page]') && typeof window.AxiomStandardStorefront.dispatchCollectionUpdate === 'function') {
        window.AxiomStandardStorefront.dispatchCollectionUpdate(root, promise, url);
      }
    }

    function fetchSection(url, requestOptions) {
      var sectionId = getSectionId();
      if (!sectionId) {
        window.location.assign(url.toString());
        return;
      }

      cancelFilterPreview();
      if (activeFetchController) activeFetchController.abort();
      var fetchController = new AbortController();
      activeFetchController = fetchController;

      var sectionUrl = new URL(url.toString());
      sectionUrl.searchParams.set('section_id', sectionId);
      setFilteringState(true);
      closeFilterDrawer();

      var resolveUpdate;
      var rejectUpdate;
      var updatePromise = new Promise(function (resolve, reject) {
        resolveUpdate = resolve;
        rejectUpdate = reject;
      });
      updatePromise.catch(function () {});
      dispatchStandardUpdate(url, updatePromise);

      fetch(sectionUrl.toString(), {
        headers: { 'Accept': 'text/html' },
        signal: fetchController.signal
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Filter section request failed');
          return response.text();
        })
        .then(function (html) {
          var parser = new DOMParser();
          var nextDocument = parser.parseFromString(html, 'text/html');
          replaceRenderedSection(nextDocument, url, requestOptions);
          var renderedRoot = document.querySelector(rootSelector) || root;
          if (renderedRoot.matches('[data-search-page]')) {
            resolveUpdate({
              totalCount: parseInt(renderedRoot.dataset.resultsCount || '0', 10) || undefined
            });
          } else {
            resolveUpdate({
              productsCount: parseInt(renderedRoot.dataset.productsCount || '0', 10) || undefined
            });
          }
        })
        .catch(function (error) {
          if (error && error.name === 'AbortError') {
            rejectUpdate(error);
            return;
          }
          rejectUpdate(error);
          window.location.assign(url.toString());
        })
        .finally(function () {
          if (activeFetchController === fetchController) {
            activeFetchController = null;
            setFilteringState(false);
          }
        });
    }

    function submitFilterForm(form, delay, requestOptions) {
      if (!form) return;
      cancelFilterPreview();
      clearTimeout(filterSubmitTimer);
      filterSubmitTimer = setTimeout(function () {
        fetchSection(getSerializedFilterUrl(form), requestOptions);
      }, delay || 0);
    }

    function initPriceSlider(slider) {
      if (!slider || slider.dataset.sliderBound === 'true') return;
      slider.dataset.sliderBound = 'true';
      var group = slider.closest('.filter-group-inner');
      if (!group) return;
      var minInput = group.querySelector('[data-price-min-input]');
      var maxInput = group.querySelector('[data-price-max-input]');
      var minRange = slider.querySelector('[data-price-range-min]');
      var maxRange = slider.querySelector('[data-price-range-max]');
      var track = slider.querySelector('.price-slider-track');
      var leftHandle = slider.querySelector('.price-slider-handle.left');
      var rightHandle = slider.querySelector('.price-slider-handle.right');
      if (!minInput || !maxInput || !minRange || !maxRange) return;

      var minLimit = parsePriceValue(minRange.min, 0);
      var maxLimit = parsePriceValue(maxRange.max, minLimit);
      var minGap = 0;

      function syncFromValues(source, commitInput) {
        var sourceIsMinInput = source === 'minInput';
        var sourceIsMaxInput = source === 'maxInput';
        var sourceIsTextInput = sourceIsMinInput || sourceIsMaxInput;
        var parsedMinInput = parsePriceValue(minInput.value, null);
        var parsedMaxInput = parsePriceValue(maxInput.value, null);
        var minValue = sourceIsTextInput
          ? (parsedMinInput === null ? minLimit : parsedMinInput)
          : parsePriceValue(minRange.value, minLimit);
        var maxValue = sourceIsTextInput
          ? (parsedMaxInput === null ? maxLimit : parsedMaxInput)
          : parsePriceValue(maxRange.value, maxLimit);
        minValue = Math.max(minLimit, Math.min(minValue, maxLimit));
        maxValue = Math.max(minLimit, Math.min(maxValue, maxLimit));

        if (source === 'maxRange' || source === 'maxInput') {
          if (maxValue < minValue + minGap) maxValue = minValue + minGap;
        } else {
          if (minValue > maxValue - minGap) minValue = maxValue - minGap;
        }

        minValue = Math.max(minLimit, minValue);
        maxValue = Math.min(maxLimit, maxValue);

        minRange.value = minValue;
        maxRange.value = maxValue;
        if (source === 'minRange' || (sourceIsMinInput && commitInput)) {
          minInput.value = formatPriceValue(minValue);
        }
        if (source === 'maxRange' || (sourceIsMaxInput && commitInput)) {
          maxInput.value = formatPriceValue(maxValue);
        }

        var span = Math.max(1, maxLimit - minLimit);
        slider.style.setProperty('--price-min-pct', (((minValue - minLimit) / span) * 100) + '%');
        slider.style.setProperty('--price-max-pct', (((maxValue - minLimit) / span) * 100) + '%');
      }

      function valueFromPointer(event) {
        var rect = (track || slider).getBoundingClientRect();
        var x = Math.max(rect.left, Math.min(event.clientX, rect.right));
        var isRTL = document.documentElement.getAttribute('dir') === 'rtl';
        var pct = rect.width > 0
          ? (isRTL ? (rect.right - x) / rect.width : (x - rect.left) / rect.width)
          : 0;
        return minLimit + pct * (maxLimit - minLimit);
      }

      function dragHandle(source, handle, event) {
        if (!event || event.button > 0) return;
        event.preventDefault();
        if (handle) handle.classList.add('is-dragging');

        function update(pointerEvent) {
          var value = valueFromPointer(pointerEvent);
          if (source === 'minRange') minRange.value = value;
          else maxRange.value = value;
          syncFromValues(source);
        }

        function stop() {
          document.removeEventListener('pointermove', update);
          document.removeEventListener('pointerup', stop);
          document.removeEventListener('pointercancel', stop);
          if (handle) handle.classList.remove('is-dragging');
          (source === 'minRange' ? minInput : maxInput).dispatchEvent(new Event('change', { bubbles: true }));
        }

        update(event);
        document.addEventListener('pointermove', update);
        document.addEventListener('pointerup', stop, { once: true });
        document.addEventListener('pointercancel', stop, { once: true });
      }

      minRange.addEventListener('input', function () { syncFromValues('minRange'); });
      maxRange.addEventListener('input', function () { syncFromValues('maxRange'); });
      minRange.addEventListener('change', function () { minInput.dispatchEvent(new Event('change', { bubbles: true })); });
      maxRange.addEventListener('change', function () { maxInput.dispatchEvent(new Event('change', { bubbles: true })); });
      minInput.addEventListener('input', function () { syncFromValues('minInput'); });
      maxInput.addEventListener('input', function () { syncFromValues('maxInput'); });
      minInput.addEventListener('change', function () { syncFromValues('minInput', true); });
      maxInput.addEventListener('change', function () { syncFromValues('maxInput', true); });
      if (leftHandle) leftHandle.addEventListener('pointerdown', function (event) { dragHandle('minRange', leftHandle, event); });
      if (rightHandle) rightHandle.addEventListener('pointerdown', function (event) { dragHandle('maxRange', rightHandle, event); });
      syncFromValues('initial');
    }

    function bindFilterAccordions() {
      root.querySelectorAll('[data-filter-toggle]').forEach(function (btn) {
        if (btn.dataset.filterToggleBound === 'true') return;
        btn.dataset.filterToggleBound = 'true';
        btn.addEventListener('click', function () {
          var group = btn.closest('.filter-group');
          if (!group) return;
          var body = group.querySelector('.filter-group-body');
          var expanded = group.classList.toggle('open');
          btn.setAttribute('aria-expanded', String(expanded));
          if (body) body.hidden = !expanded;
        });
      });
    }

    function bindFilterInputs() {
      var desktopForm = root.querySelector(config.desktopFormSelector || '#collection-filters-form');
      var mobileForm = root.querySelector(config.mobileFormSelector || '#mobile-collection-filters-form');

      root.querySelectorAll('[data-native-filter-input]').forEach(function (input) {
        if (input.dataset.filterInputBound === 'true') return;
        input.dataset.filterInputBound = 'true';
        input.addEventListener('change', function () {
          syncFilterVisual(input);
          var form = input.form || desktopForm || mobileForm;
          var dropdown = input.closest('[data-filter-dropdown]');
          if (dropdown) {
            submitFilterPreview(form, input.classList.contains('price-input') ? 350 : 0);
            return;
          }
          var isMobileForm = mobileForm && form === mobileForm;
          if (isMobileForm) {
            submitFilterPreview(form, input.classList.contains('price-input') ? 350 : 0);
            return;
          }
          submitFilterForm(form, input.classList.contains('price-input') ? 350 : 80);
        });
        if (mobileForm && input.form === mobileForm && input.matches('[data-price-min-input], [data-price-max-input]')) {
          input.addEventListener('input', function () {
            submitFilterPreview(mobileForm, 350);
          });
          input.addEventListener('keydown', function (event) {
            if (event.key !== 'Enter') return;
            event.preventDefault();
            submitFilterPreview(mobileForm, 0);
          });
        }
      });

      root.querySelectorAll('[data-color-filter-grouped="true"]').forEach(function (group) {
        if (group.dataset.groupBound === 'true') return;
        group.dataset.groupBound = 'true';
        group.addEventListener('click', function (event) {
          event.preventDefault();
          var inputs = Array.prototype.slice.call(group.querySelectorAll('[data-native-filter-input]'));
          var enabledInputs = inputs.filter(function (input) { return !input.disabled; });
          if (!enabledInputs.length) return;

          var nextChecked = !enabledInputs.some(function (input) { return input.checked; });
          enabledInputs.forEach(function (input) {
            input.checked = nextChecked;
            syncFilterVisual(input);
          });

          var targetForm = enabledInputs[0].form || desktopForm || mobileForm;
          var dropdown = group.closest('[data-filter-dropdown]');
          if (dropdown) {
            submitFilterPreview(targetForm, 0);
            return;
          }
          var isMobileForm = mobileForm && targetForm === mobileForm;
          if (isMobileForm) submitFilterPreview(targetForm, 0);
          else submitFilterForm(targetForm, 80);
        });
      });

      [desktopForm, mobileForm].forEach(function (form) {
        if (!form || form.dataset.filterSubmitBound === 'true') return;
        form.dataset.filterSubmitBound = 'true';
        form.addEventListener('submit', function (event) {
          event.preventDefault();
          var isMobileForm = mobileForm && form === mobileForm;
          var activeElement = document.activeElement;
          var activeDropdown = activeElement && activeElement.closest
            ? activeElement.closest('[data-filter-dropdown]')
            : null;
          if (activeDropdown) {
            closeFilterDropdown(activeDropdown, false, false);
            submitFilterForm(form, 0);
            return;
          }
          if (
            isMobileForm &&
            activeElement &&
            activeElement.matches &&
            activeElement.matches('[data-price-min-input], [data-price-max-input]')
          ) {
            submitFilterPreview(form, 0);
            return;
          }
          submitFilterForm(form, 0);
        });
      });

      root.querySelectorAll('.drawer-apply').forEach(function (button) {
        if (button.dataset.filterApplyBound === 'true') return;
        button.dataset.filterApplyBound = 'true';
        button.addEventListener('click', function (event) {
          var form = button.form || mobileForm;
          if (!form) return;
          event.preventDefault();
          submitFilterForm(form, 0);
        });
      });
    }

    function bindActiveFilterLinks() {
      var selector = config.activeLinkSelector || '.active-filters a[href], .drawer-clear[href]';
      root.querySelectorAll(selector).forEach(function (link) {
        if (link.dataset.activeFilterBound === 'true') return;
        link.dataset.activeFilterBound = 'true';
        link.addEventListener('click', function (event) {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          var groupedRemovalUrl = link.dataset.filterRemoveGrouped === 'true'
            ? buildGroupedFilterRemovalUrl(link)
            : null;
          fetchSection(groupedRemovalUrl || new URL(link.href, window.location.origin));
        });
      });
    }

    function getSortUrl(sortSelect) {
      var form = sortSelect.form;
      var ownsFilterState = form && form.matches('[data-filter-form], [data-mobile-filter-form]');
      var url = ownsFilterState
        ? getSerializedFilterUrl(form)
        : new URL(window.location.href);

      url.searchParams.set('sort_by', sortSelect.value);
      url.searchParams.delete('page');
      return url;
    }

    function bindSortSelect() {
      root.querySelectorAll('[data-sort-select]').forEach(function (sortSelect) {
        if (sortSelect.dataset.sortBound === 'true') return;
        sortSelect.dataset.sortBound = 'true';
        sortSelect.addEventListener('change', function () {
          fetchSection(getSortUrl(sortSelect));
        });
      });
    }

    function bindSortDropdowns() {
      root.querySelectorAll('[data-sort-dropdown]').forEach(function (group) {
        if (group.dataset.sortDropdownBound === 'true') return;
        group.dataset.sortDropdownBound = 'true';

        var sortSelect = group.querySelector('[data-sort-select]');
        var currentLabel = group.querySelector('[data-sort-current]');
        if (!sortSelect) return;

        group.querySelectorAll('[data-sort-option]').forEach(function (option) {
          option.addEventListener('click', function () {
            var nextValue = option.dataset.sortValue || '';
            var valueChanged = sortSelect.value !== nextValue;
            sortSelect.value = nextValue;

            group.querySelectorAll('[data-sort-option]').forEach(function (item) {
              var isSelected = item === option;
              item.classList.toggle('is-active', isSelected);
              item.setAttribute('aria-selected', isSelected ? 'true' : 'false');
            });

            if (currentLabel) currentLabel.textContent = option.textContent.trim();
            closeFilterDropdown(group, false, false);
            if (valueChanged) sortSelect.dispatchEvent(new Event('change', { bubbles: true }));
          });
        });
      });
    }

    function bindDrawer() {
      var filterDrawer = getFilterDrawer();
      getOpenFilterButtons().forEach(function (openBtn) {
        if (openBtn.dataset.drawerBound === 'true') return;
        openBtn.dataset.drawerBound = 'true';
        openBtn.addEventListener('click', function () {
          var currentDrawer = getFilterDrawer();
          if (!currentDrawer) return;
          if (currentDrawer.getAttribute('aria-hidden') === 'false') closeFilterDrawer();
          else openFilterDrawer();
        });
      });

      var closeButtons = Array.prototype.slice.call(root.querySelectorAll('[data-close-filter-drawer]'));
      if (filterDrawer) {
        filterDrawer.querySelectorAll('[data-close-filter-drawer]').forEach(function (btn) {
          if (closeButtons.indexOf(btn) === -1) closeButtons.push(btn);
        });
      }

      closeButtons.forEach(function (btn) {
        if (btn.dataset.drawerCloseBound === 'true') return;
        btn.dataset.drawerCloseBound = 'true';
        btn.addEventListener('click', function () { closeFilterDrawer(); });
      });

      if (filterDrawer && filterDrawer.dataset.drawerSurfaceBound !== 'true') {
        filterDrawer.dataset.drawerSurfaceBound = 'true';
        filterDrawer.addEventListener('click', function (event) {
          if (event.target === filterDrawer) {
            event.preventDefault();
            event.stopPropagation();
            closeFilterDrawer();
          }
        });
        filterDrawer.addEventListener('pointerdown', function (event) {
          if (event.target !== filterDrawer) return;
          event.preventDefault();
          event.stopPropagation();
          closeFilterDrawer();
        }, true);
      }
    }

    function bindGlobalKeys() {
      if (!window.AxiomFilterRendererEscapeBound) {
        window.AxiomFilterRendererEscapeBound = true;
        document.addEventListener('keydown', function (event) {
          if (event.key !== 'Escape') return;
          var openDrawer = document.querySelector('#filterDrawer[aria-hidden="false"]');
          if (!openDrawer) return;
          openDrawer.classList.remove('is-open');
          openDrawer.setAttribute('aria-hidden', 'true');
          if (!openDrawer.classList.contains('filter-drawer--panel')) {
            document.body.style.overflow = '';
          }
          var ownerRoot = openDrawer.closest('[data-collection-page], [data-search-page]');
          if (!ownerRoot && openDrawer.dataset.filterDrawerOwner) {
            ownerRoot = document.querySelector('[data-section-id="' + openDrawer.dataset.filterDrawerOwner + '"]');
          }
          if (ownerRoot) {
            ownerRoot.querySelectorAll('[data-open-filter-drawer]').forEach(function (button) {
              button.setAttribute('aria-expanded', 'false');
            });
          }
          if (openDrawer.dataset.filterDrawerOwner) {
            document.querySelectorAll('[data-sticky-filter-trigger][data-sticky-filter-trigger-owner="' + openDrawer.dataset.filterDrawerOwner + '"] [data-open-filter-drawer]').forEach(function (button) {
              button.setAttribute('aria-expanded', 'false');
            });
          }
        });
      }

      if (window.AxiomFilterRendererPopstateBound) return;
      window.AxiomFilterRendererPopstateBound = true;
      window.addEventListener('popstate', function () {
        window.location.reload();
      });
    }

    function bindEditorLifecycle() {
      if (window.AxiomFilterRendererEditorLifecycleBound) return;
      window.AxiomFilterRendererEditorLifecycleBound = true;
      document.addEventListener('shopify:section:unload', function (event) {
        var sectionId = event.detail && event.detail.sectionId;
        if (!sectionId && event.target && event.target.id && event.target.id.indexOf('shopify-section-') === 0) {
          sectionId = event.target.id.replace('shopify-section-', '');
        }
        if (!sectionId) return;

        var openDropdown = window.AxiomOpenFilterDropdown;
        if (
          openDropdown &&
          openDropdown.root &&
          (
            openDropdown.root.dataset.sectionId === sectionId ||
            openDropdown.root === event.target ||
            (event.target && event.target.contains && event.target.contains(openDropdown.root))
          )
        ) {
          window.AxiomOpenFilterDropdown = null;
        }

        document.querySelectorAll('#filterDrawer[data-filter-drawer-portal="true"]').forEach(function (drawer) {
          if (drawer.dataset.filterDrawerOwner === sectionId) drawer.remove();
        });
        document.querySelectorAll('[data-sticky-filter-trigger][data-sticky-filter-trigger-portal="true"]').forEach(function (trigger) {
          if (trigger.dataset.stickyFilterTriggerOwner === sectionId) trigger.remove();
        });
      });
    }

    function bindStickyFilterOffset() {
      if (stickyFilterResizeObserver) {
        stickyFilterResizeObserver.disconnect();
        stickyFilterResizeObserver = null;
      }
      if (stickyFilterResizeHandler) {
        window.removeEventListener('resize', stickyFilterResizeHandler);
        stickyFilterResizeHandler = null;
      }

      var trigger = getStickyFilterTrigger();
      if (!trigger) {
        setScrollToTopOffset(0);
        return;
      }

      updateScrollToTopOffset();
      if (typeof ResizeObserver !== 'undefined') {
        stickyFilterResizeObserver = new ResizeObserver(function () {
          updateScrollToTopOffset();
        });
        stickyFilterResizeObserver.observe(trigger);
      }
      stickyFilterResizeHandler = updateScrollToTopOffset;
      window.addEventListener('resize', stickyFilterResizeHandler);
    }

    bindFilterAccordions();
    bindFilterInputs();
    bindActiveFilterLinks();
    bindSortSelect();
    bindSortDropdowns();
    root.querySelectorAll('[data-price-slider]').forEach(initPriceSlider);
    bindFilterDropdowns();
    portalFilterDrawer();
    portalStickyFilterTrigger();
    bindDrawer();
    bindGlobalKeys();
    bindEditorLifecycle();
    bindStickyFilterOffset();

    return {
      fetchSection: fetchSection
    };
  }

  window.AxiomFilterRenderer = {
    init: initFilterRenderer
  };
})();
